import { SignatureTokenEnum } from "@/lib/enum/signature-token.enum";

export type SignatureTokenConfigType = {
  token: SignatureTokenEnum;
  w: number;
  h: number;
};

export function isCrossToken(token: string) {
  return token === SignatureTokenEnum.CROSS_TOKEN.toString();
}

export function isSignatureToken(token: string) {
  return [
    SignatureTokenEnum.SIGNATURE_QR_TOKEN.toString(),
    SignatureTokenEnum.SIGNATURE_IMAGE_TOKEN.toString(),
    SignatureTokenEnum.SIGNATURE_TOKEN.toString()
  ].includes(token);
}

export function isQrCodeToken(token: string) {
  return [SignatureTokenEnum.SIGNATURE_QR_TOKEN.toString(), SignatureTokenEnum.SIGNATURE_TOKEN.toString()].includes(
    token
  );
}

export const SignatureQRTokenConfig: SignatureTokenConfigType = {
  token: SignatureTokenEnum.SIGNATURE_QR_TOKEN,
  w: 60,
  h: 35
};

export const CrossTokenConfig: SignatureTokenConfigType = {
  token: SignatureTokenEnum.CROSS_TOKEN,
  w: 6,
  h: 6
};

export const SignatureImageTokenConfig: SignatureTokenConfigType = {
  token: SignatureTokenEnum.SIGNATURE_IMAGE_TOKEN,
  w: 45,
  h: 20
};

export const TextFieldConfig = {
  token: SignatureTokenEnum.FREE_TEXT_TOKEN
};
